import { render, staticRenderFns } from "./CheckboxItem.vue?vue&type=template&id=5e613768"
import script from "./CheckboxItem.vue?vue&type=script&lang=js"
export * from "./CheckboxItem.vue?vue&type=script&lang=js"
import style0 from "./CheckboxItem.vue?vue&type=style&index=0&id=5e613768&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@5.2.7_webpack@5.89.0__lodash@4.18.1_prettier@2.8.8_twig@1_5816a434900cfed2b1d7b77d38625343/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports